export default "__VITE_ASSET__COgUtivQ__"